import { useQuery } from '@tcs/common/hooks/useQuery';
import { PromissoryNote } from '@tcs/client-portal-api/types/PromissoryNote';

interface Props {
  loading: boolean;
  data?: PromissoryNote;
}

export const usePromissoryNote = (
  accountNumber?: string,
  assetCode?: string
): Props => {
  const { data, isLoading: loading } = useQuery<PromissoryNote, Error>(
    `/accounts/${accountNumber}/${assetCode}/PromissoryNote`,
    {
      refetchOnMount: false,
      enabled: accountNumber !== undefined,
    }
  );
  return {
    loading,
    data,
  };
};

export default usePromissoryNote;
